// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .NominationMainContainer {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 15px;
  padding: 8px 10px 5px 10px;
  margin: 10px 8px 10px 8px;
} */

.Nominations_NominationMainContainer__P-fKO {
  padding: 8px 10px 5px 10px;
  background: #ffffff;
  border-radius: 20px;
  margin: 10px 12px 10px 12px;
}

/* ===================================== */
/* CARD */
/* ===================================== */

.Nominations_nominationCard__X1KLw {
  border-bottom: 1px solid #dcdcdc;
  padding: 16px 0;
}

.Nominations_nominationCard__X1KLw:last-child {
  border-bottom: none;
}

/* ===================================== */
/* HEADER */
/* ===================================== */

.Nominations_nominationHeader__gnHYM {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.Nominations_userImage__MyEVT {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  object-fit: cover;
}

.Nominations_userInfo__4ICQO {
  margin-left: 14px;
}

.Nominations_userInfo__4ICQO h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
}

.Nominations_nominationCount__vZ44Y {
  display: inline-flex;
  align-items: center;
  gap: 4px;

  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);

  cursor: pointer;
}

.Nominations_dropdownIcon__n3vXH {
  font-size: 10px;
  display: flex;
  align-items: center;
}

/* ===================================== */
/* EXPANDED SECTION */
/* ===================================== */

.Nominations_nominationList__M7gnz {
  margin-top: 18px;
  margin-left: 76px;
}

.Nominations_nominationItem__rPkex {
  display: flex;
  align-items: flex-start;
  gap: 14px;

  background: #f5f5f5;
  border-radius: 18px;

  padding: 14px;
  margin-bottom: 14px;
}

.Nominations_nominationUserImage__mIxsR {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.Nominations_nominationContent__QwWZz {
  flex: 1 1;
}

.Nominations_nominationContent__QwWZz p {
  margin: 0;
  color: #4d4d4d;
  line-height: 1.5;
}

.Nominations_nominatedByName__A2FgP {
  margin: 0 0 6px 0;

  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.Nominations_nominationDescription__dDZXx {
  margin: 0;

  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.75);
}

.Nominations_nominationFooter__ZVAZY {
  display: flex;
  justify-content: flex-end;

  margin-top: 8px;

  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

/* ===================================== */
/* BUTTONS */
/* ===================================== */

.Nominations_actionButtons__KhrQ\\+ {
  display: flex;
  gap: 16px;
  margin-top: 20px;
}

.Nominations_clearButton__IM\\+xD,
.Nominations_nominateButton__JvjHd {
  flex: 1 1;

  border: none;
  border-radius: 30px;

  padding: 12px;

  background: #efefef;
  color: #333333;

  cursor: pointer;
  font-size: 16px;
}

.Nominations_clearButton__IM\\+xD:hover,
.Nominations_nominateButton__JvjHd:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/Moderator/Nominations.module.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;;AAEH;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C,SAAS;AACT,0CAA0C;;AAE1C;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C,WAAW;AACX,0CAA0C;;AAE1C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER,eAAe;EACf,yBAAyB;;EAEzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C,qBAAqB;AACrB,0CAA0C;;AAE1C;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,mBAAmB;EACnB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;;EAEjB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;;EAET,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;;EAEzB,eAAe;;EAEf,eAAe;EACf,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C,YAAY;AACZ,0CAA0C;;AAE1C;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;;EAEP,YAAY;EACZ,mBAAmB;;EAEnB,aAAa;;EAEb,mBAAmB;EACnB,cAAc;;EAEd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":["/* .NominationMainContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #fff;\r\n  border-radius: 15px;\r\n  padding: 8px 10px 5px 10px;\r\n  margin: 10px 8px 10px 8px;\r\n} */\r\n\r\n.NominationMainContainer {\r\n  padding: 8px 10px 5px 10px;\r\n  background: #ffffff;\r\n  border-radius: 20px;\r\n  margin: 10px 12px 10px 12px;\r\n}\r\n\r\n/* ===================================== */\r\n/* CARD */\r\n/* ===================================== */\r\n\r\n.nominationCard {\r\n  border-bottom: 1px solid #dcdcdc;\r\n  padding: 16px 0;\r\n}\r\n\r\n.nominationCard:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n/* ===================================== */\r\n/* HEADER */\r\n/* ===================================== */\r\n\r\n.nominationHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.userImage {\r\n  width: 54px;\r\n  height: 54px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.userInfo {\r\n  margin-left: 14px;\r\n}\r\n\r\n.userInfo h3 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  color: #333333;\r\n}\r\n\r\n.nominationCount {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n\r\n  font-size: 13px;\r\n  color: rgba(0, 0, 0, 0.6);\r\n\r\n  cursor: pointer;\r\n}\r\n\r\n.dropdownIcon {\r\n  font-size: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* ===================================== */\r\n/* EXPANDED SECTION */\r\n/* ===================================== */\r\n\r\n.nominationList {\r\n  margin-top: 18px;\r\n  margin-left: 76px;\r\n}\r\n\r\n.nominationItem {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 14px;\r\n\r\n  background: #f5f5f5;\r\n  border-radius: 18px;\r\n\r\n  padding: 14px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.nominationUserImage {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.nominationContent {\r\n  flex: 1;\r\n}\r\n\r\n.nominationContent p {\r\n  margin: 0;\r\n  color: #4d4d4d;\r\n  line-height: 1.5;\r\n}\r\n\r\n.nominatedByName {\r\n  margin: 0 0 6px 0;\r\n\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n.nominationDescription {\r\n  margin: 0;\r\n\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.nominationFooter {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n\r\n  margin-top: 8px;\r\n\r\n  font-size: 12px;\r\n  color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/* ===================================== */\r\n/* BUTTONS */\r\n/* ===================================== */\r\n\r\n.actionButtons {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.clearButton,\r\n.nominateButton {\r\n  flex: 1;\r\n\r\n  border: none;\r\n  border-radius: 30px;\r\n\r\n  padding: 12px;\r\n\r\n  background: #efefef;\r\n  color: #333333;\r\n\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n}\r\n\r\n.clearButton:hover,\r\n.nominateButton:hover {\r\n  opacity: 0.9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NominationMainContainer": `Nominations_NominationMainContainer__P-fKO`,
	"nominationCard": `Nominations_nominationCard__X1KLw`,
	"nominationHeader": `Nominations_nominationHeader__gnHYM`,
	"userImage": `Nominations_userImage__MyEVT`,
	"userInfo": `Nominations_userInfo__4ICQO`,
	"nominationCount": `Nominations_nominationCount__vZ44Y`,
	"dropdownIcon": `Nominations_dropdownIcon__n3vXH`,
	"nominationList": `Nominations_nominationList__M7gnz`,
	"nominationItem": `Nominations_nominationItem__rPkex`,
	"nominationUserImage": `Nominations_nominationUserImage__mIxsR`,
	"nominationContent": `Nominations_nominationContent__QwWZz`,
	"nominatedByName": `Nominations_nominatedByName__A2FgP`,
	"nominationDescription": `Nominations_nominationDescription__dDZXx`,
	"nominationFooter": `Nominations_nominationFooter__ZVAZY`,
	"actionButtons": `Nominations_actionButtons__KhrQ+`,
	"clearButton": `Nominations_clearButton__IM+xD`,
	"nominateButton": `Nominations_nominateButton__JvjHd`
};
export default ___CSS_LOADER_EXPORT___;
